import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HistoryHintService } from 'src/app/core/services/graph-history/history-hint.service';

/**
 * Añade el header `X-Action-Hint` a toda petición saliente cuando el frontend
 * ha anunciado qué acción está ejecutando vía `HistoryHintService.pushHint(...)`.
 *
 * El backend usa esta pista para decidir el `action_type` exacto a escribir
 * en el historial (p. ej. RENAME_IDEA vs UPDATE_IDEA_STYLE vs
 * UPDATE_IDEA_DESCRIPTION — todas pasan por el mismo endpoint CRUD).
 *
 * Se excluyen deliberadamente las llamadas al propio endpoint de historial
 * para que no se auto-etiqueten.
 */
@Injectable()
export class ActionHintInterceptor implements HttpInterceptor {

	constructor(private hintService: HistoryHintService) {}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		const hint = this.hintService.currentHint;
		if (!hint) return next.handle(req);
		if (req.url.includes('/history')) return next.handle(req);

		const cloned = req.clone({ setHeaders: { 'X-Action-Hint': hint } });
		return next.handle(cloned);
	}
}
